import React from "react";

function Footer() {
  return (
    <footer className="site-footer">
      <span>© 2026 MUHAMMAD MAAZ</span>
      <span>BUILT WITH REACT · NODE · CARE</span>
    </footer>
  );
}

export default Footer;
